


const parentNode = (root, parentStopSelector) => {

    let parent ;
    const a = root;
    const els = [];

    while (a) {
        if( a.tagName == parentStopSelector.toUpperCase() ){
            return a;
        }   
        else if( a.hasAttribute('id') && a.id == parentStopSelector ){
            return a;
        }
        else if( a.hasAttribute('class') && a.classList.contains(parentStopSelector) ){
            return a;
        }
        //els.unshift(a);
        a = a.parentNode;
    }

    return a;
}

const mutationObserver = (selector) => {
	const targetNode = document.querySelector(selector);

        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };


        const callback = function(mutationList) {
            // Use traditional 'for loops' for IE 11
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    console.log('A child node has been added or removed.');
                    console.log(selector);
                    const ukupno  = document.querySelectorAll(selector + " tr").length;
                    const selektovani = document.querySelectorAll(selector + " input[type='checkbox']:checked").length;
                }
                else if (mutation.type === 'attributes') {
                    console.log(`The ${mutation.attributeName} attribute was modified.`);

                    //const parent = ctx.parentNode(mutation.target, 'td');

                    console.log( 'nesto', parent );
                }
            }
        };

        const passFn = ( ctx )=>{
            return callback;
        }
        const clb  = passFn( parentNode );
        // Create an observer instance linked to the callback function

        const observer = new MutationObserver( callback );

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        // Later, you can stop observing
        //observer.disconnect();
}

export {mutationObserver, parentNode};